export enum AdvancedFilterPropsVulnerabilities {
  default = 'all vulnerabilities',
  activity_only = 'active vulnerabilities',
  resolved_only = 'resolved vulnerabilities',
}
export enum AdvancedFilterPropsPestSightings {
  default = 'all pest sightings',
  activity_only = 'active pest sightings',
  resolved_only = 'resolved pest sightings',
}
